import request from '@/utils/request'

// getAreaList
export function getAreaList(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6300/getAreaList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getFeedNoList
export function getFeedNoList(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6300/getFeedNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// getCableTypeList
export function getCableTypeList(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6300/getCableTypeList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getEpms6300List
export function getEpms6300List(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6300/getEpms6300List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epms6300Xls
export function epms6300Xls(param) {
  let data = param
  return request({
    url: `/electricMaterial/epms6300/epms6300Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `Cable Schedule.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}